import { actions } from "./Reducer";

/**
 * Actions that fire saga watchers
 */

// Singular
export const updatePendingSupplierProductAction = (body) => ({
  type: actions.UPDATE_PENDING_SUPPLIER_PRODUCT,
  payload: body,
});

export const getSingelPendingSupplierAction = (id) => ({
  type: actions.GET_SINGEL_PENDING_SUPPLIER_PRODUCT,
  payload: id
})

export const deleteSinglePendingSupplierPoduct = (id) => ({
  type:actions.DELETE_SINGLE_PENDING_SUPPLIER_PRODUCT,
  payload: id
})

export const moderateCreateSinglePendingSupplierProductAction = (id, mode) => ({
  type: actions.MODERATE_CREATE_SINGLE_PENDING_SUPPLIER_PRODUCT,
  payload: id,
  mode
})
// Plural
export const getPendingSupplierProductsAction = (body) => ({
  type: actions.GET_PENDING_SUPPLIER_PRODUCTS,
  payload: body,
});

/**
 * Actions that are fired by redux-saga watchers
 */

// Singular
export const updatePendingSupplierProductSuccessAction = (product) => ({
  type: actions.UPDATE_PENDING_SUPPLIER_PRODUCT_SUCCESS,
  payload: product,
});

export const getSinglePendingSupplierProductSuccessAction = (product) => ({
  type: actions.GET_SINGEL_PENDING_SUPPLIER_PRODUCT_SUCCESS,
  payload: product
})

export const deleteSinglePendingSupplierProductSuccessAction = (id) => ({
  type: actions.DELETE_SINGLE_PENDING_SUPPLIER_PRODUCT_SUCCESS,
  payload: id
})
export const moderateCreateSinglePendingSupplierProductSuccessAction = (id) => ({
  type: actions.MODERATE_CREATE_SINGLE_PENDING_SUPPLIER_PRODUCT_SUCCESS,
  payload: id
})
// Plural
export const getPendingSupplierProductsSuccessAction = (products) => ({
  type: actions.GET_PENDING_SUPPLIER_PRODUCTS_SUCCESS,
  payload: products,
});

/**
 * Misc
 */

export const setPendingSupplierProductsIsLoadingAction = (isLoading) => ({
  type: actions.SET_PENDING_SUPPLIER_PRODUCTS_IS_LOADING,
  payload: isLoading,
});

export const setPendingSupplierProductsCountAction = (count) => ({
  type: actions.SET_PENDING_SUPPLIER_PRODUCTS_COUNT,
  payload: count,
});
